import { get } from "../axios";
import { responseIsSuccessful } from "../global-helpers";
import { formatContactObject } from "./api-contacts";
import { Contact } from "../models/Contact";
import {
  formatObjectWithNotes,
  formatPhones,
  formatProjectOrContractObject
} from "./api-helpers";
import { Crew } from "../models/Crew";
import { Item } from "../models/Item";
import { Project } from "../models/Project";

function generateQueryParams(searchTerm) {
  return searchTerm && searchTerm.length ? `?search_term=${searchTerm}` : "";
}

export async function searchContacts(searchTerm) {
  const queryParams = generateQueryParams(searchTerm);
  return await get(
    `search/contacts/${queryParams}`,
    window.localStorage.apiToken
  )
    .then(res => {
      if (responseIsSuccessful(res) && res.data.contacts) {
        return res.data.contacts.map(c => {
          formatContactObject(c);
          return new Contact(c);
        });
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function searchContracts(searchTerm) {
  const queryParams = generateQueryParams(searchTerm);
  return await get(
    `search/contracts/${queryParams}`,
    window.localStorage.apiToken
  )
    .then(res => {
      if (responseIsSuccessful(res) && res.data.contracts) {
        return res.data.contracts;
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function searchCrews(searchTerm) {
  const queryParams = generateQueryParams(searchTerm);
  return await get(`search/crews/${queryParams}`, window.localStorage.apiToken)
    .then(res => {
      if (responseIsSuccessful(res) && res.data.crews) {
        return res.data.crews.map(c => {
          formatObjectWithNotes(c);
          if (c.crew_supervisor) {
            formatPhones(c.crew_supervisor);
          }
          return new Crew(c);
        });
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function searchItems(searchTerm) {
  const queryParams = generateQueryParams(searchTerm);
  return await get(`search/items/${queryParams}`, window.localStorage.apiToken)
    .then(res => {
      if (responseIsSuccessful(res) && res.data.items) {
        return res.data.items.map(i => new Item(i));
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function searchProjects(searchTerm) {
  const queryParams = generateQueryParams(searchTerm);
  return await get(
    `search/projects/${queryParams}`,
    window.localStorage.apiToken
  )
    .then(res => {
      if (responseIsSuccessful(res) && res.data.projects) {
        return res.data.projects.map(p => {
          formatProjectOrContractObject(p);
          return new Project(p);
        });
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function searchUsers(searchTerm) {
  const queryParams = generateQueryParams(searchTerm);
  return await get(`search/users/${queryParams}`, window.localStorage.apiToken)
    .then(res => {
      if (responseIsSuccessful(res) && res.data.users) {
        return res.data.users;
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}
